import { Reveal } from "../components/Reveal";
import { useUI } from "../context/UIContext";
import { ArrowRight, Bolt } from "lucide-react";

const CHAPTERS = [
  {
    n: "01",
    title: "Energieberatung für KMU & Privathaushalte",
    text: "Persönliche, unabhängige Tarifberatung für Haushalte, Gewerbe und Industrie – ehrlich und mit Blick auf langfristige Kostenersparnis.",
  },
  {
    n: "02",
    title: "Erstanalyse bei Preiserhöhung & Insolvenz",
    text: "Wir prüfen Sparpotenziale für Ihren spezifischen Fall – gerade bei Preiserhöhungen oder Anbieterinsolvenz. Nutzen Sie Ihr Sonderkündigungsrecht unmittelbar nach Erhalt der Preiserhöhung.",
    highlight: "Sonderkündigungsrecht",
  },
  {
    n: "03",
    title: "Günstiger einkaufen über den Spotmarkt",
    text: "Für Industrie beschaffen wir über einen Beschaffungsmix des Spotmarkts günstiger – ohne die teils sehr hohen Risiko- und Spekulationszuschläge des Terminmarkts.",
    highlight: "Spotmarkt",
  },
];

export const EnergyCoach = () => {
  const { openUpload } = useUI();
  return (
    <section className="bg-blue-950 py-24 sm:py-32 relative overflow-hidden" data-testid="energy-coach-section">
      <div className="absolute -top-40 -left-40 h-[500px] w-[500px] rounded-full bg-blue-500/10 blur-[120px] pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-blue-300 mb-5">
              <Bolt className="h-3.5 w-3.5" /> Energy Coach
            </div>
            <h2 className="text-4xl sm:text-5xl font-heading font-semibold tracking-tight text-white leading-[1.05]">
              Ihr persönlicher <span className="font-serif italic text-blue-300">Energie-Coach.</span>
            </h2>
          </div>
          <p className="lg:col-span-4 text-slate-300 leading-relaxed">
            Von der Erstanalyse bis zur strategischen Beschaffung – wir begleiten Sie bei jedem Schritt.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 rounded-3xl overflow-hidden border border-white/10">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div className="group relative h-full bg-blue-950 p-8 sm:p-10 min-h-[300px] hover:bg-blue-900 transition-colors duration-500" data-testid={`coach-chapter-${c.n}`}>
                <span className="absolute right-6 top-4 text-7xl font-heading font-semibold text-white/5 select-none">{c.n}</span>
                <div className="relative z-10">
                  <span className="h-1.5 w-10 rounded-full bg-blue-400 mb-6 block" />
                  <h3 className="text-xl font-heading text-white mb-3">{c.title}</h3>
                  <p className="text-sm text-slate-300 leading-relaxed">{c.text}</p>
                  {c.highlight && (
                    <span className="mt-4 inline-block rounded-full bg-blue-500/15 text-blue-200 text-xs px-3 py-1.5 border border-blue-400/20">
                      {c.highlight}
                    </span>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-6">
          <button
            onClick={openUpload}
            className="group rounded-full bg-white hover:bg-blue-50 text-blue-800 px-8 py-4 font-semibold transition-colors duration-300 flex items-center gap-2"
            data-testid="coach-sofortcheck-btn"
          >
            Sofort-Check starten
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
          <p className="text-sm text-slate-400">Kostenlos & unverbindlich · Für Haushalte, Gewerbe und Industrie</p>
        </div>
      </div>
    </section>
  );
};
